// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Ant Design Customizations */
.ant-layout {
  background: #f5f5f5;
}

.ant-menu {
  font-size: 14px;
}

.ant-btn {
  border-radius: 6px;
  font-weight: 500;
}

.ant-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ant-table {
  border-radius: 8px;
}

.ant-input,
.ant-select-selector {
  border-radius: 6px;
}

/* Custom Utility Classes */
.text-center {
  text-align: center;
}

.mb-16 {
  margin-bottom: 16px;
}

.mb-24 {
  margin-bottom: 24px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-24 {
  margin-top: 24px;
}

.p-16 {
  padding: 16px;
}

.p-24 {
  padding: 24px;
}

/* Responsive Utilities */
.d-none-mobile {
  display: block;
}

.d-block-mobile {
  display: none;
}

@media (max-width: 768px) {
  .d-none-mobile {
    display: none;
  }
  
  .d-block-mobile {
    display: block;
  }
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

/* Error States */
.error-message {
  color: #ff4d4f;
  text-align: center;
  padding: 20px;
}

/* Success States */
.success-message {
  color: #52c41a;
  text-align: center;
  padding: 20px;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animation Classes */
.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-in {
  animation: slideIn 0.3s ease-in-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Print Styles */
@media print {
  .no-print {
    display: none !important;
  }
  
  body {
    background: white !important;
  }
}

/* Page Footer - Common styling for all pages */
.page-footer {
  margin-top: 4rem;
  padding: 2rem;
  text-align: center;
  border-top: 2px solid rgba(79, 70, 229, 0.2);
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%);
  border-radius: 12px;
}

.page-footer p {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.page-footer strong {
  color: #4f46e5;
  font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,8FAA8F;EAC9F,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Global Styles */\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Ant Design Customizations */\r\n.ant-layout {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.ant-menu {\r\n  font-size: 14px;\r\n}\r\n\r\n.ant-btn {\r\n  border-radius: 6px;\r\n  font-weight: 500;\r\n}\r\n\r\n.ant-card {\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.ant-table {\r\n  border-radius: 8px;\r\n}\r\n\r\n.ant-input,\r\n.ant-select-selector {\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Custom Utility Classes */\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.mb-16 {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.mb-24 {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.mt-16 {\r\n  margin-top: 16px;\r\n}\r\n\r\n.mt-24 {\r\n  margin-top: 24px;\r\n}\r\n\r\n.p-16 {\r\n  padding: 16px;\r\n}\r\n\r\n.p-24 {\r\n  padding: 24px;\r\n}\r\n\r\n/* Responsive Utilities */\r\n.d-none-mobile {\r\n  display: block;\r\n}\r\n\r\n.d-block-mobile {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .d-none-mobile {\r\n    display: none;\r\n  }\r\n  \r\n  .d-block-mobile {\r\n    display: block;\r\n  }\r\n}\r\n\r\n/* Loading Spinner */\r\n.loading-spinner {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 200px;\r\n}\r\n\r\n/* Error States */\r\n.error-message {\r\n  color: #ff4d4f;\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n/* Success States */\r\n.success-message {\r\n  color: #52c41a;\r\n  text-align: center;\r\n  padding: 20px;\r\n}\r\n\r\n/* Custom Scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n/* Animation Classes */\r\n.fade-in {\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.slide-in {\r\n  animation: slideIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n/* Print Styles */\r\n@media print {\r\n  .no-print {\r\n    display: none !important;\r\n  }\r\n  \r\n  body {\r\n    background: white !important;\r\n  }\r\n}\r\n\r\n/* Page Footer - Common styling for all pages */\r\n.page-footer {\r\n  margin-top: 4rem;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  border-top: 2px solid rgba(79, 70, 229, 0.2);\r\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.05) 0%, rgba(124, 58, 237, 0.05) 100%);\r\n  border-radius: 12px;\r\n}\r\n\r\n.page-footer p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.page-footer strong {\r\n  color: #4f46e5;\r\n  font-weight: 600;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
